import { render, staticRenderFns } from "./examExcept.vue?vue&type=template&id=65876a8a"
import script from "./examExcept.vue?vue&type=script&lang=js"
export * from "./examExcept.vue?vue&type=script&lang=js"
import style0 from "./examExcept.vue?vue&type=style&index=0&id=65876a8a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports